<template>
  <div :class="b()" :style="styleSizeName">
    <div :class="b('title')" v-html="titleFormatter && titleFormatter(dataChart)"></div>
    <div v-show="hasData" :ref="id" :style="styleChartName"></div>
    <template v-if="!hasData">
      <empty></empty>
    </template>
  </div>
</template>

<script>
import init from '@/mixins/chart';
export default {
  name: 'treemap',
  mixins: [init],
  computed: {
    labelShow() {
      return this.vaildData(this.option.labelShow, false);
    },
    fontSize() {
      return this.option.fontSize || 14;
    },
    color() {
      return this.option.color || '#fff';
    },
    hasData() {
      return this.dataChart?.length > 0;
    }
  },
  methods: {
    updateChart() {
      const optionData = this.deepClone(this.dataChart) || [];
      const option = {
        tooltip: (() => {
          return Object.assign(
            (() => {
              if (this.formatter) {
                return {
                  formatter: name => {
                    return this.formatter(name, this.dataChart);
                  }
                };
              }
              return {};
            })(),
            {
              textStyle: {
                fontSize: this.option.tipFontSize,
                color: this.option.tipColor || '#fff'
              }
            }
          );
        })(),
        series: (() => {
          const list = [
            {
              type: 'treemap',
              roam: false, //是否开启拖拽漫游（移动和缩放）
              nodeClick: false, //点击节点后的行为,false无反应
              breadcrumb: { show: false }, //去除指示标签
              label: {
                normal: {
                  show: this.labelShow,
                  textStyle: {
                    fontSize: this.fontSize,
                    color: this.color
                  }
                }
              },
              data: (() => {
                let list = optionData;
                if (this.option.notCount) {
                  list = list.filter(ele => {
                    if (ele.value !== 0 && ele.value) {
                      return true;
                    }
                  });
                }
                if (this.option.sort) {
                  list.sort(function(a, b) {
                    return a.value - b.value;
                  });
                }
                return list;
              })(),
              itemStyle: this.ishasprop(!this.switchTheme, {
                color: params => this.getColor(params.dataIndex)
              })
            }
          ];
          return list;
        })()
      };
      this.myChart.setOption(option, true);

      this.chartClick();
    }
  }
};
</script>
